const Footer = () => {

        return (
            <footer className="w-sceen p-7 bg-indigo-600">
                <p className="mt-3 text-base text-white sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                 Copyright &copy; 2021 Global Travel Telecom - All Rights Reserved.
                </p>
            </footer>
        )
};
export default Footer;